export function shouldUsePaidCyclePlanChange(
  subscriptionStatus: string | null | undefined,
  currentPlanIsFree: boolean | null | undefined,
): boolean {
  return subscriptionStatus === 'active' && currentPlanIsFree === false;
}

export type PaidPlanSelectionRoute =
  | 'initial_paid_checkout'
  | 'paid_plan_change'
  | 'blocked_inconsistent_paid_lifecycle';

export type PaidBillingLifecycle = {
  status?: string | null;
  currentPlanIsFree?: boolean | null;
  billingCycle?: string | null;
  billingPeriodStart?: string | null;
  billingPeriodEnd?: string | null;
  paidThroughDate?: string | null;
  cancellationEffectiveAt?: string | null;
};

const validDate = (value: string | null | undefined): number | null => {
  if (!value) return null;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : null;
};

export function hasExistingPaidBillingCycle(
  lifecycle: PaidBillingLifecycle | null | undefined,
): boolean {
  if (
    !lifecycle ||
    lifecycle.status !== 'active' ||
    lifecycle.currentPlanIsFree !== false ||
    !['monthly', 'yearly'].includes(String(lifecycle.billingCycle))
  ) {
    return false;
  }

  const periodStart = validDate(lifecycle.billingPeriodStart);
  const periodEnd = validDate(lifecycle.billingPeriodEnd);
  const paidThrough = validDate(lifecycle.paidThroughDate);
  return periodStart !== null && periodEnd !== null && paidThrough !== null &&
    periodStart < periodEnd && paidThrough === periodEnd;
}

export function classifyPaidPlanSelection(
  lifecycle: PaidBillingLifecycle | null | undefined,
): PaidPlanSelectionRoute {
  if (!lifecycle || lifecycle.currentPlanIsFree === true) {
    return 'initial_paid_checkout';
  }
  if (hasExistingPaidBillingCycle(lifecycle)) {
    return 'paid_plan_change';
  }
  return 'blocked_inconsistent_paid_lifecycle';
}
